/* eslint-disable */
import {AxiosResponse} from 'axios';
import HttpRequest from '@/services/http-request';

export const registerBackground = (payload: any): Promise<AxiosResponse> => HttpRequest.post('api/auth/save/background', payload);

export const getBackground = (): Promise<AxiosResponse> => HttpRequest.get('api/auth/get/background');
